/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Upgrade_Plan_Modal_Actions_AcknowledgeInputs */

const es_components_upgrade_plan_modal_actions_acknowledge = /** @type {(inputs: Components_Upgrade_Plan_Modal_Actions_AcknowledgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entiendo`)
};

const en_components_upgrade_plan_modal_actions_acknowledge = /** @type {(inputs: Components_Upgrade_Plan_Modal_Actions_AcknowledgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I understand`)
};

/**
* | output |
* | --- |
* | "I understand" |
*
* @param {Components_Upgrade_Plan_Modal_Actions_AcknowledgeInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_upgrade_plan_modal_actions_acknowledge = /** @type {((inputs?: Components_Upgrade_Plan_Modal_Actions_AcknowledgeInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Upgrade_Plan_Modal_Actions_AcknowledgeInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_upgrade_plan_modal_actions_acknowledge(inputs)
	return en_components_upgrade_plan_modal_actions_acknowledge(inputs)
});
export { components_upgrade_plan_modal_actions_acknowledge as "components.upgrade_plan_modal.actions.acknowledge" }